const initialState = {
    'detalleAutorizador': {},
    'styleExitoso':false
};

export function registroDbkRdc(state = initialState, action) {
	switch (action.type) {
	case 'SET_DETAIL_DBK':
		return {
			...state,
            detalleAutorizador: action.detalleAutorizador,
            styleExitoso:action.styleExitoso
		}
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/autorizadorDBK/km0/reducer.js